import React from 'react'
import injectSheet from 'react-jss'
import styles from './lines.styles'

const LINE_SIZES = {
  large: 5,
  medium: 8,
  narrow: 12
}

const Lines = ({ classes, lineHeight }) => {
  const n = LINE_SIZES[lineHeight]
  return (
    <div className={classes.container}>
      {Array.from(Array(n).keys()).map((el, i) => (
        <div key={i} className={classes.line} />
      ))}
    </div>
  )
}

export default injectSheet(styles)(Lines)
